import Typewriter from 'typewriter-effect';
import { useEffect} from 'react';
const Mysecpic=()=>{
    // Good morning code
    let curDate=new Date();
   curDate=curDate.getHours();
    let getValue='';
    let cssstyle={}
    if(curDate>=1 && curDate <12){
        getValue='Good Morning';
        cssstyle.color='green';
    }
    else if(curDate>=12 && curDate <19){
         getValue='Good Afternoon';
         cssstyle.color='orange';
    }
    else{
        getValue='Good Night';
        cssstyle.color='black'
        cssstyle.fontWeight='bold'
    }
    // end good morning
    // Arrow code
    const goToBtn=()=>{
        window.scroll({top:750,left:0,behavior:"smooth"});
    }
    const listenToScroll=()=>{
        // const WinScroll=document.body.scrollTop || document.documentElement.scrollTop;
    }
    useEffect(()=>{
        window.addEventListener("scroll",listenToScroll)
        return ()=>window.removeEventListener("scroll",listenToScroll);
    },[]);
    // end Arrow code
    return(
        <>
            <div className="container-fluid" id='home'>
                <div className="row">
                    <div className="col-md-12 hero-bg">
                       <div className="hero-bg-shadow-box">
                         <div>
                         <h1> Hii, <span style={cssstyle}>{getValue}</span><br /> Welcome To My Portfolio Page</h1>
                          <p style={{color:'#2196f3', fontFamily: 'Ubuntu,sans-serif'}}>
                          <Typewriter
                                options={{
                                    autoStart:true,
                                    loop:true,
                                    delay:60,
                                    strings:['Work HTML CSS JS & React JS....','Frontend Developer....','React Js....','Node Js....','Mongo DB....']
                                }}
                            />
                          </p>
                         </div>
                         <div onClick={goToBtn}>
                         <i class="fa-solid fa-chevron-down"></i>
                         </div>
                       </div>
                    </div>
                </div>
             </div>
        </>
    )
}
export default Mysecpic;